import {SET_ANSWER} from '../actions/answers'
import {RESET} from '../actions/survey'
import update from 'immutability-helper'

const initialState = {};

const handleSetAnswer = (state, {question: {id}, answerIndex}) => {
    if (!answerIndex) {
        return update(state, {$unset: [id]})
    }
    return update(state, {[id]: {$set: answerIndex}});
};

export default (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case RESET:
            return initialState;
        case SET_ANSWER:
            return handleSetAnswer(state, payload);
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/answers.js